import type { TFunction } from 'i18next';
import { takeLoginLock } from 'services/api/authService';
import { intlLocaleOf } from 'config/languages';

/** What to tell a player whose sign-in failed: a self-exclusion, too many
 *  wrong passwords, or the usual wrong-credentials line. */
export function loginRefusalMessage(t: TFunction, language: string): string {
  const lock = takeLoginLock();
  if (!lock) return t('wrong_credentials');
  if (lock.retryAfter) {
    return t('too_many_login_attempts', {
      minutes: Math.max(1, Math.ceil(lock.retryAfter / 60)),
    });
  }
  if (lock.permanent || !lock.lockedUntil) return t('account_locked_permanent');
  const until = new Date(lock.lockedUntil).toLocaleString(
    intlLocaleOf(language),
    {
      dateStyle: 'medium',
      timeStyle: 'short',
    }
  );
  return t('account_locked_until', { until });
}
